<script setup lang="ts">
defineProps<{
  offer: Offer
}>()

// LATER: add with Shop functionality
// const { data: artist, suspense } = useArtistBySlug(() => {
//   const offerArtistSlugId = props.offer.artist?.slug_id
//   if (!offerArtistSlugId) {
//     throw new Error('Offer has no artist')
//   }

//   return offerArtistSlugId
// })

const { data: offers, suspense } = useRandomOffers(5)
onServerPrefetch(async () => {
  await suspense()
})

const heroMultiLinkProps = useHeroMultiLink('offers_artists')
</script>

<template>
  <div class="flex flex-col gap-36">
    <AlOfferSlider
      v-if="offers"
      :offers="
        offers.map((offer) => ({
          name: offer.name,
          slug: `${offer.slug}-${offer.slug_id}`,
          thumbnail: {
            alt: offer.image_alt,
            src: offer.image_url,
          },
        }))
      "
    />

    <AlHeroMultiLink v-bind="heroMultiLinkProps" />

    <!-- LATER: add with Shop functionality -->
    <!-- <AlArtistTeaser
      v-if="artist"
      :artist="{
        name: artist.name,
        slug: `${artist.slug}-${artist.slug_id}`,
        thumbnail: {
          src: artist.image_url,
        },
        text: artist.description,
      }"
    /> -->

    <AlMoreArtistsAndRegionsSection />

    <AlContactForm />
  </div>
</template>
